import {Button, Form, Input} from "semantic-ui-react";
import {IItem} from "../../interfaces/Item";
import {useAppDispatch} from "../../app/hooks";
import {HORIZONTAL_LINE, VERTICAL_LINE} from "../../utils/ItemTypes";
import {ChangeObjectResize} from "../MainActions";
import { round } from "../../utils/constants";
import { useTranslation } from "react-i18next";

interface Props {
  style: any;
  selectedItem: IItem;
  pxInMM: number;
  onChangeWithStyle: (propName: string, propValue: any, propNameStyle: string, propValueStyle: any) => void;
  onChange: (propName: string, propValue: any) => void;
  onChangeNoHistory: (propName: string, propValue: any) => void;
}

export const LineForm = ({style, selectedItem, pxInMM, onChangeWithStyle, onChange, onChangeNoHistory}: Props) => {
  const dispatch = useAppDispatch();
  const {t} = useTranslation();
  return (
    <Form style={style.form}>
      <Form.Field inline style={style.field}>
        <label>{t("x_from")}:</label>
        <Input
          fluid
          size="small"
          style={{width: "100%"}}
          type="number"
          value={round(selectedItem.xInMM)}
          onChange={(e) => {
            onChangeWithStyle("xInMM", Number(e.target.value), "left", `${Number(e.target.value) * pxInMM}px`);
            if (selectedItem.type === VERTICAL_LINE) {
              onChangeNoHistory("xToInMM", Number(e.target.value));
            } else {
              onChangeNoHistory("width", Math.abs(Number(e.target.value) - (selectedItem.xToInMM || 0)));
            }
          }}
        />
      </Form.Field>
      <Form.Field inline style={style.field}>
        <label>{t("y_from")}:</label>
        <Input
          fluid
          size="small"
          style={{width: "100%"}}
          type="number"
          value={round(selectedItem.yInMM)}
          onChange={(e) => {
            onChangeWithStyle("yInMM", Number(e.target.value), "top", `${Number(e.target.value) * pxInMM}px`);
            if (selectedItem.type === HORIZONTAL_LINE) {
              onChangeNoHistory("yToInMM", Number(e.target.value));
            } else {
              onChangeNoHistory("width", Math.abs(Number(e.target.value) - (selectedItem.yToInMM || 0)));
            }
          }}
        />
      </Form.Field>
      <Form.Field inline style={style.field}>
        <label>{t("x_to")}:</label>
        <Input
          fluid
          size="small"
          style={{width: "100%"}}
          type="number"
          value={round(selectedItem.xToInMM)}
          disabled={selectedItem.type === VERTICAL_LINE}
          onChange={(e) => {
            dispatch(ChangeObjectResize(selectedItem, Math.abs(Number(e.target.value) - (selectedItem.xInMM || 0)), "xToInMM", Number(e.target.value)));
            // onChange("xToInMM", Number(e.target.value));
            // onChange("width", Math.abs(Number(e.target.value) - (selectedItem.xInMM || 0)));
          }}
        />
      </Form.Field>
      <Form.Field inline style={style.field}>
        <label>{t("y_to")}:</label>
        <Input
          fluid
          size="small"
          style={{width: "100%"}}
          type="number"
          value={round(selectedItem.yToInMM)}
          onChange={(e) => {
            dispatch(ChangeObjectResize(selectedItem, Math.abs(Number(e.target.value) - (selectedItem.yInMM || 0)), "yToInMM", Number(e.target.value)));
            // onChange("yToInMM", Number(e.target.value));
            // onChange("width", Math.abs(Number(e.target.value) - (selectedItem.yInMM || 0)));
          }}
          disabled={selectedItem.type === HORIZONTAL_LINE}
        />
      </Form.Field>
      <Form.Field inline style={style.field}>
        <label>{t("width")}:</label>
        <Input
          fluid
          size="small"
          style={{width: "100%"}}
          type="number"
          value={round(selectedItem.lineWidth) || 0}
          onChange={(e) => {
            onChange("lineWidth", Number(e.target.value));
          }}
        />
      </Form.Field>
      <Form.Field inline style={style.field}>
        {/* <label>{t("bring_to_back")}:</label>
        <Form.Checkbox
          checked={selectedItem.bringBack === 1 ? true : false}
          onChange={(e, data) => {
            onChange("bringBack", selectedItem.bringBack === 1 ? 2 : 1);
          }}
        /> */}
        <Button
          compact fluid basic
          onClick={() => {
            onChange("bringBack", selectedItem.bringBack === 1 ? 2 : 1);
          }}
        >
          {t("bring_to_back")}
        </Button>
      </Form.Field>
    </Form>
  );
};
